<template lang="pug">
  .box
    VueApexCharts(
      type="area"
      height="350"
      :options="chartOptions"
      :series="series"
    )
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import { roundToK } from '@/utils/helper'

  export default {
    name: 'TotalACVChart',

    components: {
      VueApexCharts
    },

    props: ['data', 'customer_data'],

    data () {
      return {
      }
    },

    computed: {
      series () {
        return [
          {
            name: 'ACV',
            data: this.data.map((d, idx) => (d.total_mrr.total /  this.customer_data[idx].total) * 12)
          }
        ]
      },

      chartOptions () {
        return {
          chart: {
            height: 350,
            type: 'area',
            stacked: true
          },
          title: {
            text: "Annual Contract Value",
            align: 'left',
            margin: 10,
          },
          labels: this.data.map(d => d.stat_date),
          colors: ["#1DE4BD", "#6CECC1"],
          stroke: {
            curve: 'smooth',
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '12px',
              colors: ["#51507e"]
            },
            formatter: function (value, { seriesIndex, dataPointIndex, w }) {
              return "₺ " + roundToK(value);
            }
          },
          yaxis: {
            labels: {
              formatter: val => {
                return "₺ " + roundToK(val)
              },
              offsetX: -10
            }
          },
          xaxis: {
            tickPlacement: 'between',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: false,
            }
          },
          tooltip: {
            shared: true,
          },
        }
      }
    },

    methods: {
    }

  }
</script>

<style lang="scss" scoped>
</style>
